import React from 'react';
import { number, string } from 'prop-types';
import classNames from 'classnames/bind';

import useGetOfficialSiteURL from 'hooks/useGetOfficialSiteURL';
import useGetCurrentDevice from 'hooks/useGetCurrentDevice';
import useStyles from 'hooks/useStyles';
import Link from 'components/Link';
import { ExternalLinkIcon } from 'components/Icon';
import { COURSE_GROUP_TEMPLATE } from 'constants/routingPath';

import styles from './GroupLink.scss';

const cx = classNames.bind(styles);

// eslint-disable-next-line no-unused-vars
function GroupLink({ id, title }) {
  useStyles(styles);
  const { isMobile } = useGetCurrentDevice();
  const getOfficialSiteURL = useGetOfficialSiteURL();

  return (
    <Link
      className={cx(styles.root, { [styles.mobile]: isMobile })}
      to={getOfficialSiteURL(COURSE_GROUP_TEMPLATE, { id })}
    >
      <div className={styles.content}>
        <h6 className={styles.title}>{title}</h6>
        <ExternalLinkIcon className={styles.linkIcon} viewBox="0 0 24 24" />
      </div>
    </Link>
  );
}

GroupLink.propTypes = {
  id: number.isRequired,
  title: string.isRequired,
};

export default GroupLink;
